import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/generos`;

export async function getGeneros() {
  const response = await axios.get(baseUrl);
  return response.data;
}